'use client';

import { useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useZendeskEmergency } from '@flipster/features/src/shared/zendesk/use-zendesk-emergency';
import { TextButton } from '@flipster/react/design-system';
import { useBreakpoint } from '@flipster/react/misc/responsive';
import { grid, hstack } from '@flipster/styled-system/patterns';
import { getServerHostname } from '@flipster/utils/env-helper';

const DevMode = () => {
  const [isDevMode, setIsDevMode] = useState(false);

  const { breakpoint } = useBreakpoint();
  const { setTestEmergency } = useZendeskEmergency();
  useHotkeys('d+e+v', () => setIsDevMode((prevState) => !prevState));

  if (!isDevMode) return null;

  return (
    <dl
      className={grid({
        zIndex: 'modal',
        pos: 'fixed',
        left: '50%',
        bottom: 16,
        gridTemplateColumns: 'repeat(3, auto)',
        gap: 12,
        p: 12,
        border: '1px solid',
        borderColor: 'border.default.level-1',
        bgColor: 'background.default.level-1',
        rounded: 8,
        transform: 'translateX(-50%)',
        pointerEvents: 'none',
        '& > div': hstack.raw({ gap: 4 }),
        '& dt': {
          textStyle: 'Text/S/Strong',
          color: 'content.default.level-5',
        },
        '& dd': {
          textStyle: 'Text/S/Regular',
          color: 'content.accent.info',
        },
      })}
    >
      <div>
        <dt>Version:</dt>
        <dd>{process.env.NEXT_PUBLIC_VERSION || 'unknown'}</dd>
      </div>
      <div>
        <dt>Hostname:</dt>
        <dd>{getServerHostname()}</dd>
      </div>
      <div>
        <dt>BreakPoint:</dt>
        <dd>{breakpoint}</dd>
      </div>
      <div>
        <TextButton
          color='accent'
          size='small'
          label='Open emergency'
          onClick={setTestEmergency}
          css={{ pointerEvents: 'auto' }}
        />
      </div>
    </dl>
  );
};

export default DevMode;
